import React from 'react';
import { LinkProps } from '@mui/material';
import ZeusLink from './ZeusLink';

interface ZeusOrganizationAdminLinkProps extends Omit<LinkProps, 'href' | 'children'> {
  organizationAdmin: {
    id: number;
    fullName: string;
  };
}

export default function ZeusOrganizationAdminLink({
  organizationAdmin,
  ...linkProps
}: ZeusOrganizationAdminLinkProps) {
  return (
    <ZeusLink path={`/organization-admins/${organizationAdmin.id}`} {...linkProps}>
      {organizationAdmin.fullName}
    </ZeusLink>
  );
}
